var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_24561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7423 5.25H3.25749C3.02319 5.25 2.83325 5.44588 2.83325 5.6875V11.8125C2.83325 12.0541 3.02319 12.25 3.25749 12.25H11.7423C11.9766 12.25 12.1666 12.0541 12.1666 11.8125V5.6875C12.1666 5.44588 11.9766 5.25 11.7423 5.25Z",
    stroke: "#68716E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.25V3.5C5.75 3.03587 5.93437 2.59075 6.26256 2.26256C6.59075 1.93437 7.03587 1.75 7.5 1.75C7.96413 1.75 8.40925 1.93437 8.73744 2.26256C9.06563 2.59075 9.25 3.03587 9.25 3.5V5.25",
    stroke: "#68716E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72925 8.82291C7.72925 8.9092 7.65929 8.97916 7.573 8.97916C7.4867 8.97916 7.41675 8.9092 7.41675 8.82291C7.41675 8.73661 7.4867 8.66666 7.573 8.66666C7.65929 8.66666 7.72925 8.73661 7.72925 8.82291Z",
    fill: "#68716E",
    stroke: "#68716E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_24561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.ac1f7c839f0f6f1af9abdfda6b985ada.svg";
export { ForwardRef as ReactComponent };